export default __webpack_public_path__ + "static/media/MessageUp-logo.4aeb7a31.jpg";